module.exports = __webpack_public_path__ + "img/maidenheart.9f708696.png";